import { Text, TextButton, Divider } from '@wix/wix-base-ui';
import React, { FC, useEffect } from 'react';
import { useSavedComponentActionsDispatcher } from '../../../../../../ActionsDispatcher';
import { useSavedComponents } from '../../../../../../SavedComponentsProvider';
import { SectionHeader } from '../../../../SectionHeader';
import styles from './MyDesigns.scss';
import type { MyDesignsFooterProps, MyDesignsProps } from './MyDesigns.types';
import { SnapshotItem } from './SnapshotItem/SnapshotItem';
import { useUtils } from '../../../../../../UtilsProvider';
import { symbol as Symbol } from '@wix/santa-editor-symbols';
import classnames from 'classnames';

const MyDesignsFooter: FC<MyDesignsFooterProps> = ({ onCTAClick, translate }) => (
  <div className={styles.footer} data-hook="add-panel-my-design-footer">
    <Divider long />
    <div className={styles.footerContent}>
      <div>
        <Symbol name="idea-bulb" className={styles.footerInfoIcon} />
      </div>
      <div className={styles.footerText}>
        <Text shouldTranslate={false} size="tiny" weight="thin" skin="secondary">
          {translate('add_section_MyDesigns_saved_sections_note_text')}
        </Text>
        <TextButton
          onClick={onCTAClick}
          shouldTranslate={false}
          weight="thin"
          size="tiny"
          dataHook="add-panel-my-design-footer-cta"
        >
          {translate('add_section_saved_sections_saved_sections_note_cta')}
        </TextButton>
      </div>
    </div>
  </div>
);

export const MyDesigns: FC<MyDesignsProps> = ({ section }) => {
  const { savedComponents } = useSavedComponents();
  const { dispatchMyDesignsSectionMount, dispatchSavedComponentFooterCTAClick } = useSavedComponentActionsDispatcher();
  const { shouldShowMyDesignsFooter, translate } = useUtils();
  const showMyDesignsFooter = shouldShowMyDesignsFooter();

  const {
    automationId,
    translations: { title, presetTitle },
  } = section;

  useEffect(() => {
    dispatchMyDesignsSectionMount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      data-hook={automationId}
      className={classnames(styles.section, {
        [styles.withoutFooter]: !showMyDesignsFooter,
      })}
    >
      {presetTitle ? <SectionHeader headerText={presetTitle} title={title} /> : null}
      <ul>
        {savedComponents?.map((savedComponent) => (
          <li key={savedComponent.id}>
            <SnapshotItem item={savedComponent} section={section} />
          </li>
        ))}
      </ul>
      {showMyDesignsFooter && (
        <MyDesignsFooter onCTAClick={dispatchSavedComponentFooterCTAClick} translate={translate} />
      )}
    </div>
  );
};
